<template>
    <v-app style="background: white;" :style="cssVars" id="inspire">
        <div>
            <transition name="fade-in" mode="out-in">
                <router-view :key="key" />
            </transition>
        </div>
        <errors-component></errors-component>
    </v-app>
</template>

<script>

import ErrorsComponent from './components/errors';

export default {
    name: 'App',
    components:{
        ErrorsComponent
    },
    computed: {
        bottom(){
            return this.$store.getters.bottom;
        },
        cssVars() {
            var to_return = {};
            for(var index in this.$vuetify.theme.themes.light){
                to_return['--'+index+'-color'] = this.$vuetify.theme.themes.light[index];
            }
            return to_return;
        },
        app(){
            return this.$store.getters.app;
        },
        key() {
            return this.$route.fullPath;
        },
        header(){
            return this.$store.getters.header;
        }
    },
    mounted(){
        this.$root.$eventBus.$on('left_bar', () => {
            this.open_leftbar = !this.open_leftbar;
        })
        if(this.mobileCheck()){
            this.$store.commit('navigation/SET_OPENED', false);
        }else{
            this.$store.commit('navigation/SET_OPENED', true);
        }
        /*   if(!hasTutorial()){
               setTimeout(() => {
                   var intro = this.$intro();
                   intro.onexit(() => {
                       if(!this.tutorial_confirm){
                           this.$confirm('Tutorial', 'Zauważyliśmy że opuściłeś nasz samouczek. Pamiętaj zawsze możesz zobaczyć podpowiedzi klikając w przycisk znaku zapytania w górnym menu strony. ', {accept: {text: 'Ok', color:'success'}, cancel: {text: 'Nie', visible: false}}).then(res => {})
                           this.tutorial_confirm = true;
                           setTutorial();
                       }
                   })
                   intro.start();
               },2000)
           }*/
    },
    data(){
        return{
            tutorial_confirm: false,
            open_leftbar: false,
        }
    }
};
</script>
<style lang="scss">
@import "scss/custom";
@media screen and (max-width: 1200px){
    .my-container{
        width: 100%;
        max-width: 100%;
    }
}
.v-application{
    .primary-normal{
        background: var(--primary-color) !important;
    }
    .secondary-normal{
        background: var(--secondary-color)!important;
    }
    .primary{
        background: var(--primary-color);
    }
}
.primary-normal{
    background: var(--primary-color);
}
.secondary-normal{
    background: var(--secondary-color);
}
.primary{
    background: var(--primary-color);
}
</style>
